import styled from '@emotion/styled';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { i18n, mediaQuery, openCallMeModal, useAppDispatch } from 'src/common';
import { useGetOfferQuery } from 'src/common/api/apollo/additional';
import { Button, Card, Flex, Loader, Text } from 'src/components';
import { colors, footer, header } from 'src/theme';
import { AppRoutesAdditional } from '../../_router/app.routes';


const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const TextStyle = styled(Text)({
  width: '100%',
  textAlign: 'left',
  whiteSpace: 'pre-line',
});

const TitleTextStyle = styled.div({
  textAlign: 'left',
  width: '100%',
});

const CardWrapperStyle = styled.div({
  width: '100%',
  maxWidth: '80%',
  alignSelf: 'start',
});

const TextLinkStyle = styled.a({
  display: 'inline-block',
  cursor: 'pointer',
  fontSize: 16,
  fontWeight: 700,
  color: colors.text2,
  textDecoration: 'none',

  '&:hover': {
    color: colors.primary,
  },
});

const ButtonRowStyle = styled(Flex)({
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
});

const ButtonRowWrapperStyle = styled.div({
  width: '100%',
  alignSelf: 'center',
});

const HealthQuestionnaireRejectedPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params = useParams<{ offerId: string }>();

  const { data: getOfferAdditionalData, loading: loadingOfferAdditional } = useGetOfferQuery({
    variables: { id: params.offerId || '' },
    skip: !params.offerId,
    onError: () => {
      navigate(AppRoutesAdditional.OFFERS_PREVIEW.fullPath);
    },
    fetchPolicy: 'network-only'
  });

  if (loadingOfferAdditional) return <Loader page />;
  if (!getOfferAdditionalData?.getOffer) return null;

  return (
    <FlexStyle justify="center" align="center">
      <CardWrapperStyle>
        <Card padding={30}>
          <Flex vertical gap={24} align="start">
            <Flex vertical align="start" gap={16}>
              <TitleTextStyle>
                <Text type="large" bold>
                  {i18n.t('pages.tooManyDiseases.title')}
                </Text>
              </TitleTextStyle>
              <TextStyle type="base">
                {getOfferAdditionalData.getOffer?.productTypeSpecific?.healthQuestionnaire?.messages
                  ?.map((m) => m.message)
                  .join('\n\n') ?? ''}
              </TextStyle>
            </Flex>
            <ButtonRowWrapperStyle>
              <ButtonRowStyle gap={16}>
                <TextLinkStyle
                  href={`${AppRoutesAdditional.CUSTOMER_ONLY_DATE.fullPath}`}
                >
                  {i18n.t('pages.tooManyDiseases.closeButton')}
                </TextLinkStyle>
                <Button
                  text={i18n.t('pages.tooManyDiseases.requestCallButton')}
                  onClick={() => dispatch(openCallMeModal())}
                />
              </ButtonRowStyle>
            </ButtonRowWrapperStyle>
          </Flex>
        </Card>
      </CardWrapperStyle>
    </FlexStyle >
  );
};

export default HealthQuestionnaireRejectedPage;